// modules
import { get } from 'lodash'
import { createSelector } from 'reselect'

import { patientProgramSelector } from 'src/store/modules/patient/selectors'

// utils
import { addAllValue } from 'src/utils/v5/DataTrees'

export const patientEnrollments$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientEnrollments'], [])
)

export const patientActiveProgramSelector = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['activeProgram'], {})
)

export const patientDiseases$ = createSelector(
  patientProgramSelector,
  (program = {}) =>
    get(program, ['patientDiseases'], [])
      .map((item, key) => ({
        ...item,
        key,
        title: item.name,
        label: item.name,
        value: item.uuid
      }))
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1
        } else if (a.name > b.name) {
          return 1
        }

        return 0
      })
)

export const patientDiseasesWithAll$ = createSelector(
  patientDiseases$,
  (diseases = []) => addAllValue({ list: diseases })
)

export const isEnrollmentUpdated$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['isEnrollmentUpdated'], false)
)

export const patientDiseasesLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientDiseasesLoading'], false)
)

export const patientDiseaseModalLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientDiseaseModalLoading'], false)
)

export const patientDiagnosis$ = createSelector(
  patientProgramSelector,
  (program = {}) =>
    get(program, ['patientDiagnosis'], []).map((item, key) => ({
      ...item,
      key,
      title:
        item.name ||
        `[${get(item, ['icd10', 'code'], '')}] ${get(
          item,
          ['icd10', 'title'],
          ''
        )}`,
      value: item.uuid
    }))
)

export const patientDiagnosisLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientDiagnosisLoading'], false)
)

export const patientDiagnosisModalLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientDiagnosisModalLoading'], false)
)

export const patientFollowUpCall$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['followUpCall'], {})
)

export const patientMedicalDevices$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientMedicalDevices'], [])
)

export const patientMedicalDevicesLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientMedicalDevicesLoading'], false)
)

export const diagnosisLoading$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['diagnosisLoading'], false)
)

export const diagnosisList$ = createSelector(
  patientProgramSelector,
  (program = {}) =>
    get(program, ['diagnosisList'], []).map((item) => ({
      ...item,
      key: item.uuid,
      value: item.uuid
    }))
)

export const patientOnHoldHistory$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientOnHoldHistory'], [])
)

export const patientRpmBillableHistory$ = createSelector(
  patientProgramSelector,
  (program = {}) => get(program, ['patientRpmBillableHistory'], [])
)
